import React, {type JSX} from "react";

const RequiredFieldIndicationMessage = () => {
    return (
        <p className='ss-required-field-info'>* indicates a required field</p>
    )
}

/**
 * Renders a form label, appending a required-field asterisk when `required` is truthy.
 * @param required Whether the field is required
 * @param name The id of the input the label is for
 * @param label The label content
 */
export const labelWithRequired = (required: boolean | undefined, name: string, label: React.ReactNode): JSX.Element => {
    if (required) {
        return <label htmlFor={name}>{label} <i className='ss-required-field-asterisk'>*</i></label>
    } else return <label htmlFor={name}>{label}</label>
}

export default RequiredFieldIndicationMessage;
